// These indicators are incompatible units and are intentionally rendered as
// plain stat tiles rather than a shared-axis chart, which would misrepresent
// them as comparable.
const UNIT_BY_LABEL = {
  "Land Use": "(index)",
  "Energy Use": "hours",
  "Greenhouse Gas": "kg CO2e/acre",
  "Soil Erosion": "hours (proxy)",
  "Yield Efficiency": "", // unit is the crop year's own yield_units
  "Nitrogen Intensity": "lb N/ac (est.)",
};

function formatValue(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "-";
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export default function IndicatorSummaryRow({ labels, values, yieldUnit }) {
  if (!Array.isArray(labels) || !Array.isArray(values)) return null;

  return (
    <div className="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-8">
      {labels.map((label, index) => {
        const isDisabled = label !== "Greenhouse Gas";
        let unit = UNIT_BY_LABEL[label] ?? "";
        if (label === "Yield Efficiency" && yieldUnit) {
          unit = yieldUnit;
        }
        return (
          <div
            key={label}
            aria-disabled={isDisabled ? "true" : undefined}
            className={`border rounded shadow-sm p-3 flex flex-col items-start ${
              isDisabled
                ? "border-slate-200 bg-slate-50 opacity-70"
                : "border-[rgb(230,230,230)]"
            }`}
          >
            <p className="text-[13px] text-[#666666]">{label}</p>
            <p
              className={`text-[22px] font-light ${
                isDisabled ? "text-slate-500" : "text-[rgb(0,164,229)]"
              }`}
            >
              {isDisabled ? "Pending" : formatValue(values[index])}
            </p>
            <p className="text-[12px] text-[#999999]">
              {isDisabled ? "Support coming soon" : unit}
            </p>
          </div>
        );
      })}
    </div>
  );
}
